import { useState, useEffect } from 'react';
import UnSavedChangesConfirmationModal from '../components/unsavedChanges';

const useUnsavedChanges = (properties = [], onCloseClick, accordionProperties = []) => {
  const [unSavedExists, setUnSavedExists] = useState(false);
  const [unSavedAction, setUnSavedAction] = useState(false);

  useEffect(() => {
    const dirtyProps = properties.filter(ele => ele?.isDirty);
    const dirtyAccordion = accordionProperties.filter(ele => ele?.isDirty);
    setUnSavedExists(dirtyProps.length > 0 || dirtyAccordion.length > 0);
  }, [properties, accordionProperties]);

  const handleClose = (action) => {
    if (action) {
      setUnSavedAction(false);
    } else {
      setUnSavedAction(true);
    }
  };

  const UnsavedChangesModal = () => (
    unSavedAction && (
      <UnSavedChangesConfirmationModal
        open={unSavedAction}
        handleClose={() => setUnSavedAction(false)}
        handleMainDialogClose={onCloseClick}
      />
    )
  );

  return {
    unSavedExists,
    handleClose,
    UnsavedChangesModal
  };
};

export default useUnsavedChanges;
